
export default function Banner() {

  return (
    <>
      {/* WAS USED TO DISPLAY A BANNER */}
    </>
  );
}